export default __webpack_public_path__ + "static/mapping1-d33930604bfe974a8c7c8eab9ea879a8.mp4";